import foodAndInventory from './foodAndInventory/routes';
import service from './service/routes';
import people from './people/routes';
import discounts from './discounts/routes';
import labor from './labor/routes';
import budget from './budget/routes';
import dataEntry from './dataEntry/routes';
import product from './product/routes';
import sales from './sales/routes';

import { useRootStore } from '@/myq-core';

const routes = [
  {
    path: '/home-dashboard',
    alias: '/',
    name: 'Home',
    icon: 'mdi-home',
    component: () => import('@/components/oldDashboard/th/main.vue'),
    async beforeEnter(to, from, next) {
      const store = useRootStore();
      await store.waitForUserToBeLoaded();
      const isCrewMember = store.permissions.includes('employee_portal');
      console.log({ isCrewMember, hasEmployeeRole: store.hasEmployeeRole });
      if (isCrewMember && store.hasEmployeeRole) {
        // next('/wfm/portal/myschedule');
        window.location.href = '/wfm/portal/myschedule';
      }
      next();
    },
  },
  service,
  people,
  foodAndInventory,
  discounts,
  labor,
  budget,
  dataEntry,
  product,
  sales
];

export default routes;